module.exports = __webpack_public_path__ + "img/delivery-express.e298d92f.png";